import type { LandingPageContent } from './types'

export const PV_INSTALLATEUR_FINDEN: LandingPageContent = {
  slug: 'pv-installateur-finden',
  lang: 'de',
  topicId: 'pv-installateur-finden',
  title: 'PV-Installateur finden – geprüfte Handwerksbetriebe',
  metaDescription:
    'Finden Sie passende Solarteure für Ihr Projekt. Handwerksbetriebe geben ein Angebot für Ihre ' +
    'anonyme Anfrage ab - Sie wählen, wer Sie kontaktiert.',
  keywords: [
    'PV Installateur finden',
    'Solarteur finden',
    'Photovoltaik Firma finden',
    'Solar Handwerksbetrieb finden',
    'Solarteur in der Nähe',
    'Photovoltaik Installateur Denkmalschutz',
  ],
  eyebrow: 'Installateur finden',
  h1: 'Passenden PV-Installateur (Solarteur) finden',
  intro:
    'Statt einzelne Solarteure anzuschreiben und auf Rückmeldung zu warten, drehen Sie bei Roofora ' +
    'den Prozess um: Ihre Anfrage erreicht mehrere Handwerksbetriebe gleichzeitig, die von sich aus ' +
    'ein Angebot abgeben.',
  sections: [
    { type: 'heading', text: 'Wie Sie bei Roofora einen Installateur finden' },
    {
      type: 'paragraph',
      text:
        'Sie stellen eine anonymisierte Anfrage mit Dachdaten und Verbrauch. Solarteure und ' +
        'Elektrofachbetriebe in Ihrer Region sehen diese Anfrage und können kostenlos ein Angebot ' +
        'abgeben - ganz ohne dass Sie einzelne Firmen recherchieren oder kontaktieren müssen.',
    },
    { type: 'heading', text: 'Was einen guten Solarteur ausmacht' },
    {
      type: 'list',
      items: [
        'Nachvollziehbares, konkret aufgeschlüsseltes Angebot statt Pauschalpreis',
        'Bewertungen aus abgeschlossenen Projekten',
        'Klare Garantie- und Serviceleistungen',
        'Erfahrung mit Ihrer Dach- und Anlagenart',
      ],
    },
    { type: 'heading', text: 'Regionale Verfügbarkeit von Handwerksbetrieben' },
    {
      type: 'paragraph',
      text:
        'Wie viele Betriebe für Ihre Anfrage ein Angebot abgeben, hängt von Ihrer Region ab. Sie sehen jederzeit, ' +
        'wie viele Angebote bereits vorliegen, und können in Ruhe abwarten, bis genug Vergleichswerte ' +
        'da sind.',
    },
    { type: 'heading', text: 'Für Handwerksbetriebe: Projekte in Ihrer Region finden' },
    {
      type: 'paragraph',
      text:
        'Solarteure und Elektrofachbetriebe sehen anonymisierte Anfragen aus ihrer Region - inklusive ' +
        'Dachdaten und Verbrauch, aber ohne Kontaktdaten. Ein Angebot abzugeben ist kostenlos und ' +
        'unverbindlich.',
    },
  ],
  faq: [
    {
      q: 'Was ist der Unterschied zwischen Solarteur und PV-Installateur?',
      a: 'Beide Begriffe bezeichnen dieselbe Tätigkeit - die fachgerechte Planung und Montage von Photovoltaikanlagen. "Solarteur" wird häufiger im Handwerk selbst verwendet, "PV-Installateur" eher in der Kundenkommunikation.',
    },
    {
      q: 'Muss ich selbst Handwerksbetriebe recherchieren?',
      a: 'Nein - Sie stellen eine Anfrage, passende Betriebe aus Ihrer Region geben von sich aus ein Angebot dafür ab.',
    },
    {
      q: 'Finde ich auch einen Installateur mit Denkmalschutz-Erfahrung?',
      a: 'Ja - geben Sie den Denkmalschutz-Status Ihres Gebäudes bei der Anfrage an. Betriebe mit entsprechender Erfahrung können sich gezielt darauf bewerben, statt dass Sie selbst danach suchen müssen.',
    },
  ],
  primaryCta: { label: 'Anfrage erstellen und Installateure finden', action: 'customer' },
  secondaryCta: { label: 'Als Handwerksbetrieb registrieren', action: 'craftsman' },
  relatedLinks: [
    { label: 'So funktioniert der Angebotsvergleich', href: '/pv-angebot-vergleichen' },
    { label: 'Photovoltaik-Anfrage erstellen', href: '/photovoltaik-anfrage-erstellen' },
    { label: 'Solaranlage Kosten im Überblick', href: '/solaranlage-kosten' },
    { label: 'Nur Dachmontage benötigt?', href: '/pv-module-montage' },
    { label: 'Nur Elektroinstallation benötigt?', href: '/photovoltaik-elektroinstallation' },
  ],
}
